export default {
    intro:              "Přizpůsobte si, jak AI generuje popisy vašich položek.",
    tone_label:         "Tón popisu",
    tone_selling:       "Prodejní",
    tone_professional:  "Profesionální",
    tone_friendly:      "Přátelský",
    tone_luxury:        "Luxusní / Prémiový",
    length_label:       "Délka popisu",
    length_short:       "Krátký",
    length_medium:      "Střední",
    length_long:        "Delší",
    include_label:      "Zahrnout v popisu",
    benefits_toggle:    "Výhody produktu/služby",
    benefits_tooltip:   "AI automaticky identifikuje a zdůrazní klíčové výhody vašeho produktu nebo služby v popisu.",
    cta_toggle:         "Výzvu k akci (call-to-action)",
    cta_tooltip:        "Na konec popisu přidá výzvu k akci, např. 'Objednejte ještě dnes!' nebo 'Kontaktujte nás pro více informací.'",
    custom_label:       "Vlastní instrukce",
    custom_optional:    "(volitelné)",
    use_last_used:      "Použít naposledy použité",
    custom_placeholder: "Např.: Zaměř se na ekologii, zmiň záruku, použij formální jazyk...",
    reset_defaults:     "Obnovit výchozí",
    generating:         "Generuji...",
    generate_btn:       "Vygenerovat popis přes AI",
    save_error:         "Nepodařilo se uložit nastavení",
};
